export default __webpack_public_path__ + "static/media/6.6e8b0b23.webp";